import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, ZapIcon, CheckCircleIcon, ShoppingCartIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-white relative" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-heading font-bold text-slate-900 mb-4" data-id="element-45">
            Invertí en tu futuro hoy
          </motion.h2>
          <p className="text-xl text-slate-600" data-id="element-46">
            El momento perfecto para empezar es ahora.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-24 max-w-5xl mx-auto" data-id="element-47">
          {/* Book Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          type: 'spring'
        }} className="relative w-64 h-80 md:w-80 md:h-[400px] perspective-1000" style={{
          perspective: '1000px'
        }} data-id="element-48">
            <div className="absolute inset-0 bg-gradient-to-br from-brand-blue to-blue-900 rounded-r-2xl rounded-l-sm shadow-book flex flex-col items-center justify-center p-8 text-center border-l-[12px] border-blue-950 transition-transform duration-500 hover:rotate-y-[-5deg]" style={{
            transform: 'rotateY(-15deg) rotateX(5deg)',
            transformStyle: 'preserve-3d'
          }} data-id="element-49">
              {/* Decorative elements on book cover */}
              <div className="absolute top-4 right-4 w-16 h-16 border-t-2 border-r-2 border-blue-400/30 rounded-tr-xl" data-id="element-50" />
              <div className="absolute bottom-4 left-6 w-16 h-16 border-b-2 border-l-2 border-blue-400/30 rounded-bl-xl" data-id="element-51" />

              <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mb-6 backdrop-blur-sm" data-id="element-52">
                <ZapIcon className="w-8 h-8 text-brand-green" data-id="element-53" />
              </div>
              <h3 className="text-white font-heading font-bold text-3xl md:text-4xl mb-3 leading-tight shadow-sm" data-id="element-54">
                Emprende
                <br data-id="element-55" />
                Digital
              </h3>
              <div className="w-12 h-1 bg-brand-green mb-4 rounded-full" data-id="element-56" />
              <p className="text-blue-100 text-sm md:text-base font-medium uppercase tracking-wider" data-id="element-57">
                Guía Definitiva
              </p>
            </div>
          </motion.div>

          {/* Pricing Details */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl border border-slate-100 w-full max-w-md relative overflow-hidden" data-id="element-58">
            {/* Savings Badge */}
            <div className="absolute top-0 right-0 bg-brand-green text-white text-sm font-bold px-4 py-1 rounded-bl-xl" data-id="element-59">
              Ahorrás $29.901
            </div>

            <div className="mb-8" data-id="element-60">
              <p className="text-slate-500 font-medium mb-2" data-id="element-61">Precio regular:</p>
              <p className="text-2xl text-slate-400 line-through decoration-red-400 decoration-2 font-heading" data-id="element-62">
                $49.900 ARS
              </p>
              <div className="flex items-baseline gap-2 mt-2" data-id="element-63">
                <span className="text-sm font-bold text-brand-green uppercase tracking-wider" data-id="element-64">
                  Ahora:
                </span>
                <p className="text-5xl font-heading font-extrabold text-brand-green" data-id="element-65">
                  $19.999 <span className="text-2xl" data-id="element-66">ARS</span>
                </p>
              </div>
            </div>

            <div className="space-y-4 mb-8" data-id="element-67">
              <div className="flex items-center gap-3 bg-blue-50 p-3 rounded-lg border border-blue-100" data-id="element-68">
                <img src="https://http2.mlstatic.com/frontend-assets/ui-navigation/5.19.1/mercadopago/logo__small.svg" alt="Mercado Pago" className="h-6 object-contain" data-id="element-69" />
                <p className="text-sm text-slate-700 font-medium" data-id="element-70">
                  Pagá con Mercado Pago · Hasta 12 cuotas sin interés
                </p>
              </div>
            </div>

            <motion.button whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} onClick={() => window.open('https://www.emprende-digital.com/cart/51742249156888:1', '_blank')} className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-brand-green to-emerald-500 text-white font-bold text-xl py-4 px-8 rounded-xl shadow-lg shadow-emerald-500/30 hover:shadow-emerald-500/50 transition-all duration-300 mb-6" data-id="element-71">
              <ShoppingCartIcon className="w-6 h-6" data-id="element-72" />
              Comprar Ahora
            </motion.button>

            <div className="grid grid-cols-1 gap-3" data-id="element-73">
              <div className="flex items-center gap-2 text-slate-600 text-sm" data-id="element-74">
                <ShieldIcon className="w-4 h-4 text-brand-blue" data-id="element-75" />
                <span data-id="element-76">Pago 100% seguro y encriptado</span>
              </div>
              <div className="flex items-center gap-2 text-slate-600 text-sm" data-id="element-77">
                <ZapIcon className="w-4 h-4 text-brand-blue" data-id="element-78" />
                <span data-id="element-79">Acceso inmediato al contenido</span>
              </div>
              <div className="flex items-center gap-2 text-slate-600 text-sm" data-id="element-80">
                <CheckCircleIcon className="w-4 h-4 text-brand-blue" data-id="element-81" />
                <span data-id="element-82">Garantía de satisfacción de 7 días</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}